// import {
//   Collapse,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   styled,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import { addOpenDrawer } from "store/actions/appAction";
// import { apiGetRoles } from "api/roleApi";
// import ExpandLessIcon from "assets/icons/ExpandLessIcon";
// import ExpandMoreIcon from "assets/icons/ExpandMoreIcon";
// import itemsSidebar from "assets/js/itemsSidebar";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { checkUserAccess } from "helpers/helper";

// const MobileSidebarinnerContainer = styled("div")(({ theme }) => ({
//   display: "flex",
//   flexDirection: "column",
//   padding: "24px",
// }));

// const StyledListItemButton = styled(ListItemButton)(
//   ({ theme, active }: { theme?: ThemeObjType; active?: boolean }) => ({
//     height: "50px",
//     margin: "8px 0 8px 0",
//     padding: "12px",
//     backgroundColor: active ? "none" : "#F9FBFC",
//     "&:hover": {
//       backgroundColor: "#EBF0FF52",
//     },
//   })
// );

// const StyledListItemIcon = styled(ListItemIcon)({
//   minWidth: "30px",
// });

// const StyledListItemText = styled(ListItemText)({
//   textAlign: "right",
// });

// const InfoItem = ({ data }: { data: (typeof itemsSidebar.items)[0] }) => {
//   const [open, setOpen] = useState(false);
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const subItems = Array.isArray(data.subItem) ? data.subItem : []
//   // @ts-ignore
//   const { anchor } = useSelector((state) => state).appReducer;
//   const dispatch = useDispatch();
//   const checkBySubItem = (items: any[]) => {
//     const hasAccess = items.map(x => {
//       return checkUserAccess({ checkUserAction: x.permission ? x.permission : "" })
//     }).find(x => x === true)
//     return hasAccess !== undefined
//   }
//   return (
//     <>
//       <StyledListItemButton
//         disableRipple
//         active={!open}
//         onClick={() => {
//           if (subItems.length == 0 && data.url) {
//             navigate(data.url);
//             dispatch(addOpenDrawer(false, undefined, anchor));
//           }
//           setOpen(!open);
//         }}
//       >
//         <StyledListItemIcon>
//           <img src={data.img} style={{ maxWidth: "24px" }} />
//         </StyledListItemIcon>
//         <StyledListItemText>
//           <Typography
//             variant="body2"
//             color={open ? theme.palette.text.primary : theme.palette.text.secondary}
//           >
//             {data.name}
//           </Typography>
//         </StyledListItemText>
//         {subItems.length > 0 && open ? <ExpandLessIcon /> : checkBySubItem(subItems)  ? <ExpandMoreIcon /> : null}
//       </StyledListItemButton>
//       {subItems.length > 0 && (
//         <Collapse in={open} timeout="auto" unmountOnExit>
//           {/* <ChildComponent /> */}
//           {/* @ts-ignore */}
//           {subItems.map((item, index) => {
//             const currPermission = item.permission ? item.permission : ""
//             if (item.name === "slot") {
//               return null;
//             }
//             if (!checkUserAccess({ checkUserAction: currPermission })) return null
//             return (
//               <StyledListItemButton
//                 key={index}
//                 disableRipple
//                 active={false}
//                 onClick={() => {
//                   // @ts-ignore
//                   navigate(item?.url);
//                   return dispatch(addOpenDrawer(false, undefined, anchor));
//                 }}
//               >
//                 <StyledListItemText>
//                   <Typography
//                     variant="body2"
//                     color={open ? theme.palette.text.primary : theme.palette.text.secondary}
//                   >
//                     {item.name}
//                   </Typography>
//                 </StyledListItemText>
//               </StyledListItemButton>
//             );
//           })}
//         </Collapse>
//       )}
//     </>
//   );
// };

// const MobileSidebarinner = () => {
//   const dispatch: any = useDispatch();
//   const store = useSelector((state: any) => state);
//   const business = store.businessReducer.business;
//   const token = business.token;
//   const user = business?.user;
//   // let userAccesses: any[] = [];
//   // if (user && user.User_Accesses) {
//   //   userAccesses = user.User_Accesses.map(({ AccessId }: { AccessId: any }) => AccessId);
//   // }
//   // //   const userAccesses = user?.User_Accesses?.map(({ AccessId }) => AccessId);

//   // const getCurrentAccesses = (userRole: any, roles: any[]) => {
//   //   try {
//   //     const currentRole = roles.find((item: any) => item?.fa_title === userRole);

//   //     return currentRole?.Accesses;
//   //   } catch {
//   //     return [];
//   //   }
//   // };
//   // const userRole = business?.business?.userRole;
//   const roles = store.roleReducer?.roles;

//   useEffect(() => {
//     if (!roles?.length) {
//       dispatch(apiGetRoles(token));
//     }
//   }, [token]);

//   // const accesses = getCurrentAccesses(userRole, roles);
//   // const userAccessesArray = accesses?.filter((af: any) => userAccesses.includes(af.id));
//   // const permissions = userAccessesArray
//   //   // @ts-ignore
//   //   ?.map(({ en_title }) => en_title) || []
//   const conditions = {
//      haveWarehouse: business?.business?.haveWarehouse ?? true,//این شرطه مورد داره چرا باید کسی که انبار دسترسی نداره انبارو ببینه ؟؟؟؟/
//     isAdmin: business?.user?.email && business?.user?.email === "support@chortke.app",
//     hasSmsPanel:
//       business?.business?.subscription && ![7, 10, 13, 17].includes(business?.business?.subscription.id),
//   };
//   // const returnSubPermission = (item: any) => {
//   //   // @ts-ignore
//   //   const listOfpermmission = item?.subItem?.map(({ permission }) => permission)
//   //   return listOfpermmission ? listOfpermmission : []
//   // }

//   return (
//     <MobileSidebarinnerContainer>
//       <List component="div" disablePadding>
//         {itemsSidebar.items.map((item, index) => {
//           console.log(item, 'item')
//           if ((item.condition && (conditions as any)[item.condition])) return null
//           return <InfoItem key={index} data={item} />;
//         })}
//       </List>
//     </MobileSidebarinnerContainer>
//   );
// };

// export default MobileSidebarinner;
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import { addOpenDrawer } from "store/actions/appAction";
import { apiGetRoles } from "api/roleApi";
import ExpandLessIcon from "assets/icons/ExpandLessIcon";
import ExpandMoreIcon from "assets/icons/ExpandMoreIcon";
import itemsSidebar from "assets/js/itemsSidebar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { store, useAppSelector } from "store/store";
import { checkUserAccess } from "helpers/helper";

const MobileSidebarinnerContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "24px",
}));

const StyledListItemButton = styled(ListItemButton)(
  ({ theme, active }: { theme?: ThemeObjType; active?: boolean }) => ({
    height: "50px",
    margin: "8px 0 8px 0",
    padding: "12px",
    backgroundColor: active ? "none" : "#F9FBFC",
    "&:hover": {
      backgroundColor: "#EBF0FF52",
    },
  })
);

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "30px",
});

const StyledListItemText = styled(ListItemText)({
  textAlign: "right",
});

const InfoItem = ({ data }: { data: (typeof itemsSidebar.items)[0] }) => {
  const [open, setOpen] = useState(false);
  const { getState } = store
  const theme = useTheme();
  const navigate = useNavigate();
  const token = getState().businessReducer.business?.token;

  // @ts-ignore
  const { anchor } = useSelector((state) => state).appReducer;
  const dispatch = useDispatch();
  return (
    <>
      <StyledListItemButton
        disableRipple
        active={!open}
        onClick={() => {
          if (!data.subItem && data.url) {
            navigate(data.url);
            dispatch(addOpenDrawer(false, undefined, anchor));
          } else if (data.link) {
            window.open(data.link + `/${token}`, "_blank");

          }
          setOpen(!open);
        }}
      >
        <StyledListItemIcon>
          <img src={data.img} style={{ maxWidth: "24px" }} />
        </StyledListItemIcon>
        <StyledListItemText>
          <Typography
            variant="body2"
            color={open ? theme.palette.text.primary : theme.palette.text.secondary}
          >
            {data.name}
          </Typography>
        </StyledListItemText>
        {data.subItem && open ? <ExpandLessIcon /> : data.subItem ? <ExpandMoreIcon /> : null}
      </StyledListItemButton>
      {data.subItem && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {/* <ChildComponent /> */}
          {/* @ts-ignore */}
          {data.subItem.map((item, index) => {
            if (item.name === "slot") {
              return null;
            }
            if (item.permission && checkUserAccess({ checkUserAction: item.permission }))
              return (
                <StyledListItemButton
                  key={index}
                  disableRipple
                  active={false}
                  onClick={() => {
                    // @ts-ignore
                    navigate(item?.url);
                    return dispatch(addOpenDrawer(false, undefined, anchor));
                  }}
                >
                  <StyledListItemText>
                    <Typography
                      variant="body2"
                      color={open ? theme.palette.text.primary : theme.palette.text.secondary}
                    >
                      {item.name}
                    </Typography>
                  </StyledListItemText>
                </StyledListItemButton>
              );
            else {
              return null
            }
          })}
        </Collapse>
      )}
    </>
  );
};

const MobileSidebarinner = () => {
  const dispatch: any = useDispatch();
  const store = useSelector((state: any) => state);
  const business = store.businessReducer.business;

  const user = business.user
  const User_Accesses = user.User_Accesses
  const conditions = {
    haveWarehouse: business?.business?.haveWarehouse ?? true,
    isAdmin: business?.user?.email && business?.user?.email === "support@chortke.app",
  };

  return (
    <MobileSidebarinnerContainer>
      <List component="div" disablePadding>

        {User_Accesses && User_Accesses.length > 0 ?
          itemsSidebar.items.map((item: any, index) => {
            const hasSubItem = typeof item.subItem !== "undefined"
            const s: any = item.subItem || [];
            let subItems = s.map((x: any) => {
              if (x.condition && !(conditions as any)[x.condition]) return false;
              if (x.permission && !checkUserAccess({ checkUserAction: x.permission, checkBussinesAccess: x?.businessAccess })) return false
              // if (x.permission && Accesses.includes(x.permission)) return false;
              return { ...x };
            }).filter((r: any) => typeof r !== "boolean" && r.name !== 'slot');
            // if (
            //   !item.subItem ||
            //   (item.condition && (conditions as any)[item.condition]) ||
            //   userAccessesArray
            //     // @ts-ignore
            //     ?.map(({en_title}) => en_title)
            //     // @ts-ignore
            //     .some((ac) => item?.subItem?.map(({permission}) => permission).indexOf(ac) >= 0)
            // ) {
            //   return <InfoItem key={index} data={item} />;
            // }
            if (!hasSubItem && item?.permission && !checkUserAccess({ checkUserAction: item?.permission, checkBussinesAccess: item?.businessAccess })) return null
            if (hasSubItem && subItems.length === 0) return null;
            return <InfoItem key={index} data={item} />
          })
        :<Skeleton variant="rectangular"/>
        }
      </List>
    </MobileSidebarinnerContainer>
  );
};

export default MobileSidebarinner;
